/**
 * Language code to flag emoji mapping
 */
const LANGUAGE_FLAGS: Record<string, string> = {
    // Auto-detect
    auto: '🌐',
    'auto-detect': '🌐',
    // ISO codes
    en: '🇬🇧',
    fr: '🇫🇷',
    de: '🇩🇪',
    es: '🇪🇸',
    it: '🇮🇹',
    pt: '🇵🇹',
    // Full names (as stored in conversation_language column)
    english: '🇬🇧',
    french: '🇫🇷',
    german: '🇩🇪',
    spanish: '🇪🇸',
    italian: '🇮🇹',
    portuguese: '🇵🇹',
};

/**
 * Get the flag emoji for a language code or name
 * @param language - ISO language code (e.g., 'en', 'fr') or full name (e.g., 'Spanish', 'French')
 * @returns Flag emoji or empty string if not found
 */
export const getLanguageFlag = (language: string | null): string => {
    if (!language) return '';
    return LANGUAGE_FLAGS[language.toLowerCase()] || '';
};
